import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { reducer } from './AdLibraryRedux'
import rootSaga from './AdLibrarySagas'

// Isolated store for the Ad Library feature. It is intentionally NOT part of the
// global src/redux store — the feature owns its own state and is mounted via its
// own <Provider> in AdLibraryView. See project_ad_library memory.
const sagaMiddleware = createSagaMiddleware()

const store = createStore(reducer, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(rootSaga)

export default store
